import { actionCreator } from '@ardoq/rxbeach';
import { APIWorkspaceFolder, ArdoqId, AssetPayload } from '@ardoq/api-types';

/** Used for CRUD routines */
export const workspaceFolderNamespace = 'workspacefolder';

export type MoveAssetsPayload = {
  folderId: ArdoqId | null;
  movedAssets: AssetPayload[];
};

export const moveAssets = actionCreator<MoveAssetsPayload>(
  '[assetFolders] MOVE_ASSETS'
);

export const moveAssetsSuccess = actionCreator<APIWorkspaceFolder[]>(
  '[assetFolders] MOVE_ASSETS_SUCCESS'
);

export const moveAssetsError = actionCreator(
  '[assetFolders] MOVE_ASSETS_ERROR'
);

type CreatePayload = {
  name: string;
  targetFolderId?: ArdoqId | null;
};

export const createAssetFolder = actionCreator<CreatePayload>(
  '[assetFolders] CREATE'
);

export const createAssetFolderSucceeded = actionCreator<APIWorkspaceFolder>(
  '[assetFolders] CREATE_SUCCEEDED'
);

export const createAssetFolderFailed = actionCreator(
  '[assetFolders] CREATE_FAILED'
);
